var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgList = function SvgList(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M113 28a6 6 0 0 1 .225 11.996L113 40H46a6 6 0 0 1-.225-11.996L46 28z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 34,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M88 58a6 6 0 0 1 .225 11.996L88 70H46a6 6 0 0 1-.225-11.996L46 58z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 64,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M104 88a6 6 0 0 1 .225 11.996L104 100H46a6 6 0 0 1-.225-11.996L46 88z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 94,
    r: 7
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgList);
export default ForwardRef;